import _ from "lodash";

import * as styledElements from "./ImageSetPreviewStyles";
import ModalContentWithCloseButton from "../ModalContentWithCloseButton";
import { ReactNode, useState } from "react";
import { BoardImages, MountType } from "../../../reducers/uploadedBoard";
import Modal from "../Modal";
import SVGViewer from "../SVGViewer";

const BOTTOM_TITLE = "Bottom";

interface PreviewInfo {
  title: string;
  details?: ReactNode;
  previewUrl: string;
  svgUrl: string | null;
}

export function GerberFilePreview({
  boardImages,
}: {
  boardImages: BoardImages;
}) {
  const previewInfo: PreviewInfo[] = [];

  if (boardImages.top !== null) {
    previewInfo.push({
      title: "Top",
      previewUrl: boardImages.top.detail as string,
      svgUrl: boardImages.top.svg,
    });
  }
  if (boardImages.bottom !== null) {
    previewInfo.push({
      title: BOTTOM_TITLE,
      previewUrl: boardImages.bottom.detail as string,
      svgUrl: boardImages.bottom.svg,
    });
  }

  previewInfo.push(
    ...boardImages.layers.map((layer) => {
      const formattedLayerName = _.startCase(layer.name as string);
      return {
        title: `${formattedLayerName}*`,
        previewUrl: layer.detail as string,
        svgUrl: layer.svg,
      };
    }),
  );

  return (
    <>
      <ImageSetPreview previewInfo={previewInfo} />
      <div>*As seen from top of board</div>
    </>
  );
}

export default function ImageSetPreview({
  previewInfo,
}: {
  previewInfo: PreviewInfo[];
}) {
  const [selectedPreview, setSelectedPreview] = useState<PreviewInfo | null>(
    null,
  );

  return (
    <>
      <styledElements.Table>
        <tbody>
          {previewInfo.map((preview: PreviewInfo) => (
            <styledElements.PreviewTableRow key={preview.previewUrl}>
              <styledElements.LeftSection>
                <styledElements.Title>{preview.title}</styledElements.Title>
                {preview.details}
              </styledElements.LeftSection>
              <styledElements.RightSection>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={preview.previewUrl}
                  alt={preview.title}
                  onClick={() =>
                    preview.svgUrl !== null && setSelectedPreview(preview)
                  }
                />
              </styledElements.RightSection>
            </styledElements.PreviewTableRow>
          ))}
        </tbody>
      </styledElements.Table>
      <Modal
        isOpen={selectedPreview !== null}
        onRequestClose={() => setSelectedPreview(null)}
      >
        <ModalContentWithCloseButton
          closeModal={() => setSelectedPreview(null)}
          showCloseHint
          fullScreen
          lessPadding
        >
          {selectedPreview !== null && (
            <SVGViewer
              svgInput={{ svgUrl: selectedPreview.svgUrl as string }}
              mountType={
                selectedPreview.title == BOTTOM_TITLE
                  ? MountType.BOTTOM
                  : MountType.TOP
              }
            />
          )}
        </ModalContentWithCloseButton>
      </Modal>
    </>
  );
}
